var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReportsAndSummary(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.366,
    height: 13.906,
    viewBox: "0 0 9.366 13.906",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "notebook",
    d: "M11.325,1.159V0H10.285V1.159H9.244V0H8.2V1.159H7.163V0H6.122V1.159H5.081V0H4.041V1.159H3V12.168a1.657,1.657,0,0,0,1.561,1.738H10.8a1.657,1.657,0,0,0,1.561-1.738V1.159ZM8.2,9.85H5.081V8.691H8.2Zm2.081-2.318h-5.2V6.374h5.2Zm0-2.318h-5.2V4.056h5.2Z",
    transform: "translate(-3)",
    fill: "#6f109e"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsAndSummary);
export default __webpack_public_path__ + "static/media/reports_and_summary.32df821b2b926494800019f2aba6e984.svg";
export { ForwardRef as ReactComponent };